<template>
  <span
    class="MentionLink"
  >
    <ReplyArrow
      v-if="replyTo && !replyInPill"
      :status-id="replyTo.statusId"
      :plain="!!replyTo.plain"
    />
    <!-- eslint-disable vue/no-v-html -->
    <a
      v-if="!user"
      :href="url"
      class="original"
      target="_blank"
      v-html="content"
    /><!-- eslint-enable vue/no-v-html -->
    <component
      :is="replyPreview ? 'StatusPopover' : 'UserPopover'"
      v-else
      v-bind="popoverProps"
    >
      <span
        v-if="user"
        class="new"
        :style="style"
        :class="classnames"
      >
        <MentionPill
          v-if="isPill"
          tag="a"
          class="short"
          :class="{ '-with-tooltip': shouldShowTooltip }"
          :users="[user]"
          :reply="replyInPill ? replyTo : null"
          :href="url"
          :title="shouldShowTooltip ? null : '@' + (user.screen_name_full_ui || userNameFullUi)"
          :aria-label="pillLabel"
          @click.prevent="onClick"
        >
          <NameWithEmoji
            class="shortName mention-pill-name"
            :name="pillName"
            :emoji="user.emoji"
          />
          <span
            v-if="isYou && shouldShowYous"
            :class="{ '-you': shouldBoldenYou }"
          >{{ ' ' + $t('status.you') }}</span>
        </MentionPill>
        <a
          v-else
          class="short"
          :class="{ '-with-tooltip': shouldShowTooltip }"
          :href="url"
          @click.prevent="onClick"
        >
          <!-- eslint-disable vue/no-v-html -->
          <UserAvatar
            v-if="shouldShowAvatar"
            class="mention-avatar"
            :user-id="user.id"
          /><span
            class="shortName"
          >@<span
            class="userName"
            v-html="userName"
          /><span
            v-if="shouldShowFullUserName"
            class="serverName"
            :class="{ '-faded': shouldFadeDomain }"
            v-html="'@' + serverName"
          /><UnicodeDomainIndicator
            v-if="shouldShowFullUserName"
            :user="user"
          />
          </span>
          <span
            v-if="isYou && shouldShowYous"
            :class="{ '-you': shouldBoldenYou }"
          > {{ ' ' + $t('status.you') }}</span>
          <!-- eslint-enable vue/no-v-html -->
        </a><span
          ref="full"
          class="full"
        >
          <!-- eslint-disable vue/no-v-html -->
          @<span v-html="userName" /><span v-html="'@' + serverName" />
          <!-- eslint-enable vue/no-v-html -->
        </span>
      </span>
    </component>
  </span>
</template>

<script src="./mention_link.js" />

<style lang="scss" src="./mention_link.scss" />
